<template>
  <v-container grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <h1 class="primary--text mb-4">National Interventions Analytics Dashboard</h1>
      </v-flex>
    </v-layout>

    <DateFilter @date:changed="refreshAnalytics" />

    <v-layout row wrap fill-height class="mt-1">
      <!-- Intervetion History -->
      <v-flex xs12>
        <v-card>
          <v-card-title class="subheading font-weight-bold px-4">Interventions History</v-card-title>
          <v-container class="px-4">
            <v-layout row wrap v-show="!analyticsLoading">
              <v-flex xs12>
                <BarChart v-if="countryAnalytics !== null" :values="countryAnalytics.history.values" :labels="countryAnalytics.history.labels" :height="75" />
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-center class="pt-2 pb-5" v-show="analyticsLoading">
              <v-progress-circular
                :indeterminate="true"
                :size="24"
                :width="3"
                color="grey"
              ></v-progress-circular>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>

      <!-- Interventions by State -->
      <v-flex xs12 sm6>
        <v-card>
          <v-card-title class="subheading font-weight-bold px-4">Interventions Overview by States</v-card-title>
          <v-container class="px-4">
            <v-layout row wrap v-show="!analyticsLoading">
              <v-flex xs12>
                <PieChart v-if="countryAnalytics !== null" :values="countryAnalytics.overview.values" :labels="countryAnalytics.overview.labels" :height="150" />
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-center class="pt-2 pb-5" v-show="analyticsLoading">
              <v-progress-circular
                :indeterminate="true"
                :size="24"
                :width="3"
                color="grey"
              ></v-progress-circular>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>

      <!-- Interventions by Agency -->
      <v-flex xs12 sm6>
        <v-card>
          <v-card-title class="subheading font-weight-bold px-4">Interventions Overview by Agency</v-card-title>
          <v-container class="px-4">
            <v-layout row wrap v-show="!analyticsLoading">
              <v-flex xs12>
                <PieChart v-if="countryAnalytics !== null" :values="countryAnalytics.overview_agency.values" :labels="countryAnalytics.overview_agency.labels" :height="150" />
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-center class="pt-2 pb-5" v-show="analyticsLoading">
              <v-progress-circular
                :indeterminate="true"
                :size="24"
                :width="3"
                color="grey"
              ></v-progress-circular>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>

      <!-- Intervention per State -->
      <v-flex xs12>
        <h1 class="primary--text mt-3">States</h1>
      </v-flex>
      <v-flex xs12 sm6 v-for="(stateData, index) in stateAnalytics" :key="index">
        <v-card>
          <v-card-title class="subheading font-weight-bold px-4">Interventions Overview - {{ stateData.details.name }}</v-card-title>
          <v-container class="px-4">
            <v-layout row wrap v-show="!analyticsLoading">
              <v-flex xs12>
                <PieChart :values="stateData.overview.values" :labels="stateData.overview.labels" :height="150" />
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-center class="pt-2 pb-5" v-show="analyticsLoading">
              <v-progress-circular
                :indeterminate="true"
                :size="24"
                :width="3"
                color="grey"
              ></v-progress-circular>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>

      <v-flex xs12>
        <h1 class="primary--text mt-3">Partners</h1>
      </v-flex>
      <!-- Intervention per Agency -->
      <v-flex xs12 sm6 v-for="(agencyData, index) in agencyAnalytics" :key="index + agencyData.details.name">
        <v-card>
          <v-card-title class="subheading font-weight-bold px-4">Interventions Overview - {{ agencyData.details.name }}</v-card-title>
          <v-container class="px-4">
            <v-layout row wrap v-show="!analyticsLoading">
              <v-flex xs12>
                <PieChart :values="agencyData.overview.values" :labels="agencyData.overview.labels" :height="150" />
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-center class="pt-2 pb-5" v-show="analyticsLoading">
              <v-progress-circular
                :indeterminate="true"
                :size="24"
                :width="3"
                color="grey"
              ></v-progress-circular>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>

    <MainFooter />
  </v-container>
</template>

<script>
// import Map from '@/components/Map/Map.vue'
import BarChart from '@/components/Charts/BarChart.vue'
import PieChart from '@/components/Charts/PieChart.vue'
import DateFilter from '@/components/Filters/DateFilter.vue'
import MainFooter from '@/components/Footer/MainFooter.vue'
import { setFormData } from '@/utils/http'
import { refineAnalytics } from '@/utils/analytics'

export default {
  name: 'Nema',
  components: {
    // Map,
    BarChart,
    PieChart,
    DateFilter,
    MainFooter
  },
  data () {
    return {
      isLoading: false,
      analyticsLoading: false,
      fromDate: '',
      toDate: '',
      fromDateModal: false,
      toDateModal: false,
      countryAnalytics: null,
      stateAnalytics: [],
      agencyAnalytics: [],
      mapLoading: false,
      locationMarkers: []
    }
  },
  methods: {
    fetchNemaMap () {
      this.mapLoading = true
      const params = setFormData({
        country_id: this.$settings.country
      })
      this.$http.post('location/read_by_country_with_details', params)
        .then(({ data: response }) => {
          this.mapLoading = false
          if (response.code === 200) {
            this.locationMarkers = response.data
          }
        })
    },
    fetchNemaAnalytics (from, to, period) {
      this.analyticsLoading = true
      this.countryAnalytics = null
      this.stateAnalytics = []
      this.agencyAnalytics = []
      const params = setFormData({
        country_id: this.$settings.country,
        from_timestamp: from,
        to_timestamp: to,
        period: period
      })
      this.$http.post('aid/analytics_for_nema', params)
        .then(({ data: response }) => {
          this.analyticsLoading = false
          if (response.code === 200) {
            // Country Analytics
            this.countryAnalytics = refineAnalytics('nema', response.data.country)
            // State Analytics
            response.data.states.forEach(state => {
              this.stateAnalytics.push(refineAnalytics('state', state, 0, 1))
            })
            // Agency Analytics
            response.data.agencies.forEach(state => {
              this.agencyAnalytics.push(refineAnalytics('agency', state, 0, 1))
            })
          }
        })
    },
    refreshAnalytics (payload) {
      this.fetchNemaAnalytics(payload.from, payload.to, payload.period)
    }
  }
}
</script>
